import {
  TResponsiveTableCellRendererProps,
  TResponsiveTableColumn,
  TResponsiveTableSortValue,
} from '../../../../components/common/generic/responsiveTable/types';
import { TAdminJspColumn } from '../../../../components/apia/administration/types';
import { TAccordionCellRenderer } from '../../../../components/common/generic/responsiveTable/renderers/AccordionCell';
import columnsRenderers from './columnsRenderers';

export type TJspToResponsiveParser = {
  columns: TAdminJspColumn[];
  asyncRenderer: React.NamedExoticComponent<
    TResponsiveTableCellRendererProps<Record<string, unknown>>
  >;
  accordeonAsyncRenderer: TAccordionCellRenderer<Record<string, unknown>>;
  listId: string;
};

const jspToResponsiveColumnsParser = ({
  accordeonAsyncRenderer,
  asyncRenderer,
  columns,
  listId,
}: TJspToResponsiveParser): TResponsiveTableColumn[] => {
  const listData = window.listData[listId];

  const returnArray = columns?.map((column) => {
    let currentSort: TResponsiveTableSortValue = null;
    if (column.sort === 'Up') currentSort = 'A';
    else if (column.sort === 'Down') currentSort = 'D';

    const customRenderer =
      columnsRenderers[listData.component]?.[column.name]?.renderer;
    const customAccordionRenderer =
      columnsRenderers[listData.component]?.[column.name]?.accordionRenderer;

    const returnObject: TResponsiveTableColumn = {
      additionalData: {
        sortByIndex: currentSort,
      },
      hideFromAccordion: column.hideFromAccordion,
      showAsAdditional: false,
      width: column.width,
      minWidth: column.minWidth,
      maxWidth: column.maxWidth,
      name: column.name,
      allowSorting: !column.preventSorting,
      label: column.label,
      title: column.toolTip,
      required: true,
      currentSorting: currentSort,
      showInAccordionTitle: column.showInAccordionTitle,
      dataSortBy: column.dataSortBy,
      hidden: column.hidden,
      ...(customRenderer ? { Renderer: customRenderer } : null),
      ...(customAccordionRenderer
        ? { AccordionRenderer: customAccordionRenderer }
        : null),
    };

    return returnObject;
  });
  if (window.listData[listId].additionalInfoInTable)
    returnArray?.unshift({
      showAsAdditional: true,
      label: 'moreInfo',
      name: 'moreInfo',
      Renderer: asyncRenderer,
      AccordionRenderer: accordeonAsyncRenderer,
    });
  return returnArray.filter((column) => {
    return !column.hidden;
  });
};

export default jspToResponsiveColumnsParser;
